export default __webpack_public_path__ + "b4330d573efce4fdbe5a79ae47aad18d.pdf";